import buttonStyles from '@insify/design-system/components/Button/Button.module.css';
import { headingMd, textMdSemibold, textSmSemibold, textXxsSemibold } from '@insify/design-system/typography';
import { TrackedAnchor } from '@objectiv/tracker-react';
import clsx from 'clsx';

import { usePolicies } from '../../api/queries/usePolicies';
import { hasAnyActiveCoverage } from '../../utils/policies';

import styles from './FrHealth.module.css';
import carmen from './assets/carmen.png';

type Props = {
  className?: string;
};

export const FrenchHealthInsuranceOfferBanner: React.FC<Props> = ({ className }) => {
  const { data: policies = [] } = usePolicies();
  const activePolicies = policies.filter(hasAnyActiveCoverage);

  const hasFRPolicy = activePolicies.find(({ country }) => country === 'FR');

  if (!hasFRPolicy) {
    return null;
  }

  return (
    <div className={clsx(styles.container, className)}>
      <h2 className={clsx(headingMd, styles.title)}>
        Votre mutuelle
        <br />
        en 2 minutes
      </h2>
      <TrackedAnchor
        objectiv={{ id: 'fr-health-cross-sell' }}
        className={clsx(buttonStyles.button, buttonStyles.primary, textMdSemibold, styles.button)}
        href='https://mutns.insify.fr'
        target='_blank'
        rel='noreferrer'
      >
        Obtenir mon devis
      </TrackedAnchor>
      <div className={styles.imageContainer}>
        <img className={styles.portrait} src={carmen} alt='Carmen' />
        <div className={styles.sticker}>
          <span className={clsx(textXxsSemibold, styles.top)}>
            Prenez soin de
            <br />
            vous dès
          </span>
          <span className={clsx(headingMd, styles.price)}>
            25 <span className={styles.euroSign}> €</span>
          </span>
          <span className={clsx(textSmSemibold, styles.bottom)}>par mois</span>
        </div>
      </div>
    </div>
  );
};
